import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { map, tap } from 'rxjs';
import { API_MAP } from '../../../core/helpers/api.map';
import { InternalDepartmentService } from './internal-department.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const InternalDepartmentResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
   const router = inject(Router);
  var contentService = inject(InternalDepartmentService);
  contentService.controller = API_MAP.internalDepartment + removeQueryParams(state.url).substring(1);
  return contentService.get().pipe(
      tap((d) => {
        if (!d.content) {
          let params = state.root.children.find((r) => r.params?.['lang'])?.params;
          router.navigate([(params?.['lang'] ?? 'he') + '/not-found']);
        }
      }),
      map(() => true)
    );
};
